import base64url from 'base64url';

/**
 * Checks if the WebAuthn API is supported in the current browser.
 */
export const isWebAuthnSupported = (): boolean =>
  typeof PublicKeyCredential !== 'undefined' &&
  typeof PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable === 'function';

/**
 * WebAuthn reports an explicit dismissal and a prompt timeout as the same NotAllowedError,
 * so both mean the user never completed the prompt.
 */
export const isWebAuthnUserDismissal = (error: unknown): boolean =>
  (error as Error | undefined)?.name === 'NotAllowedError';

/**
 * Encodes an ArrayBuffer to a base64url string.
 */
export const encodeArrayBuffer = (buffer: ArrayBuffer): string => base64url.encode(Buffer.from(buffer));

/**
 * Decodes a base64url string to an ArrayBuffer suitable for WebAuthn.
 * Node.js Buffer shares memory with a larger ArrayBuffer, so we need to slice it.
 */
export const decodeToArrayBuffer = (str: string): ArrayBuffer => {
  const buffer = base64url.toBuffer(str);
  return (buffer.buffer as ArrayBuffer).slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
};
